/* ABOWLLON - Urlaubs-/Versandhinweis 2026
 * 1) Blendet oben einen Urlaubsbanner ein (Waldgruen/Gold, Pfeil-&-Bogen-Thema).
 * 2) Entschaerft das Tempo-Versprechen "Schneller Versand aus Deutschland".
 *
 * "Kostenloser Versand ab 30 EUR" bleibt bewusst stehen - das ist eine
 * Preis-, keine Zeitaussage und bleibt auch im Urlaub wahr.
 *
 * WICHTIG: Aendert NICHTS dauerhaft am Theme. Ab END_DATE ist automatisch
 * wieder alles im Originalzustand - kein manueller Rueckbau noetig.
 *
 * Vorschau vor Go-Live: ?abpreview=1 an die URL haengen.
 */
(function () {
  if (window.__abUrlaub) return;
  window.__abUrlaub = true;

  var LIVE = true;                          // auf true = oeffentlich sichtbar
  var END_DATE = new Date('2026-08-01T00:00:00+02:00');
  var PREVIEW = location.search.indexOf('abpreview=1') !== -1;

  if (!PREVIEW) {
    if (!LIVE) return;
    if (new Date() >= END_DATE) return;      // Urlaub vorbei -> alles wie vorher
  }

  /* ---------- 1. Banner ---------- */

  var CSS = [
    '.ab-urlaub{position:sticky;top:0;z-index:9999;width:100%;',
    'background:linear-gradient(100deg,#12331E 0%,#1F5B32 55%,#2F7D47 100%);',
    'color:#fff;font-family:Inter,system-ui,-apple-system,Segoe UI,sans-serif;',
    'box-shadow:0 2px 18px rgba(0,0,0,.4);border-bottom:3px solid #E8B84B;}',
    '.ab-urlaub__in{max-width:1200px;margin:0 auto;padding:16px 20px;display:flex;',
    'align-items:center;justify-content:center;gap:16px;text-align:center;}',
    '.ab-urlaub__icon{font-size:30px;line-height:1;flex:0 0 auto;}',
    '.ab-urlaub__txt{display:flex;flex-direction:column;gap:3px;}',
    '.ab-urlaub__h{font-size:19px;font-weight:800;letter-spacing:.4px;text-transform:uppercase;}',
    '.ab-urlaub__h em{font-style:normal;color:#FFD98A;}',
    '.ab-urlaub__s{font-size:15px;font-weight:500;opacity:.96;}',
    '.ab-urlaub__s b{color:#FFD98A;font-weight:800;}',
    '@media(max-width:700px){',
    '.ab-urlaub__in{padding:12px 14px;gap:10px;}',
    '.ab-urlaub__icon{font-size:24px;}',
    '.ab-urlaub__h{font-size:15px;}',
    '.ab-urlaub__s{font-size:13px;}}'
  ].join('');

  function mountBanner() {
    if (document.querySelector('.ab-urlaub')) return;

    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var bar = document.createElement('div');
    bar.className = 'ab-urlaub';
    bar.setAttribute('role', 'status');

    var inner = document.createElement('div');
    inner.className = 'ab-urlaub__in';

    var icon = document.createElement('div');
    icon.className = 'ab-urlaub__icon';
    icon.textContent = '🎯';

    var txt = document.createElement('div');
    txt.className = 'ab-urlaub__txt';

    var h = document.createElement('div');
    h.className = 'ab-urlaub__h';
    h.innerHTML = 'Urlaubspause – <em>Bestellen geht weiter!</em>';

    var s = document.createElement('div');
    s.className = 'ab-urlaub__s';
    s.innerHTML = 'Du kannst ganz normal bestellen. Deine Bestellung trifft ins Ziel, sobald wir zurück sind: Versand ab dem <b>1. August 2026</b>.';

    txt.appendChild(h);
    txt.appendChild(s);
    inner.appendChild(icon);
    inner.appendChild(txt);
    bar.appendChild(inner);

    document.body.insertBefore(bar, document.body.firstChild);
  }

  /* ---------- 2. Tempo-Versprechen entschaerfen ---------- */

  var RULES = [
    ['Schneller Versand aus Deutschland', 'Versand ab 01.08.2026']
  ];

  function skip(el) {
    if (!el) return true;
    var tag = el.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') return true;
    if (el.closest('.ab-urlaub')) return true;
    return false;
  }

  function patchTexts(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var n, todo = [];
    while ((n = w.nextNode())) {
      if (skip(n.parentElement)) continue;
      if (n.nodeValue.indexOf('Schneller Versand aus Deutschland') === -1) continue;
      todo.push(n);
    }
    todo.forEach(function (node) {
      var v = node.nodeValue;
      RULES.forEach(function (r) { v = v.split(r[0]).join(r[1]); });
      if (v !== node.nodeValue) node.nodeValue = v;
    });
    return todo.length;
  }

  /* ---------- Start ---------- */

  function boot() {
    mountBanner();
    patchTexts(document.body);
    var t = null;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { patchTexts(document.body); }, 120);
    });
    obs.observe(document.body, {childList: true, subtree: true});
  }

  if (document.body) {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();
